import { render, staticRenderFns } from "./PaymentTermDialog.vue?vue&type=template&id=734f8bd2"
import script from "./PaymentTermDialog.vue?vue&type=script&lang=js"
export * from "./PaymentTermDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports